import script from "./ProjectDetails.vue?vue&type=script&lang=ts&setup=true"
export * from "./ProjectDetails.vue?vue&type=script&lang=ts&setup=true"

import "./ProjectDetails.vue?vue&type=style&index=0&id=0471d175&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0471d175"]])

export default __exports__